<template>
  <div class="rs-org-select" aria-label="orgSelect" role="navigation">
    <rs-input
      class="rs-org-select-input"
      readonly
      :size="size"
      v-model="inputVal"
      :placeholder="inputPlaceholder"
      @focus="handleFocus"
    >
      <i slot="suffix" v-if="inputVal!=''" class="rs-org-select-input-icon rs-input__icon rs-icon-circle-close" @click="clearInputValue"></i>
    </rs-input>
    <rs-collapse-transition>
      <div class="rs-org-select-tree-box" v-show="showTreeBox" :class="{mini:size=='mini',small:size=='small',large:size=='large'}">
        <rs-input
          prefix-icon="rs-icon-search"
          placeholder="搜索组织名称"
          clearable
          :size="size=='mini'?'mini':'small'"
          v-model="filterText">
        </rs-input>
        <div class="rs-org-select-tree-content">
          <rs-org-tree
            @ready="isready"
            v-if="multiple"
            ref="tree"
            :props="props"
            :node-key="nodeKey"
            show-checkbox
            default-expand-all
            :expand-on-click-node="false"
            class="rs-org-select-tree"
            :render-content="renderContent"
            :data="treeArr"
            highlight-current
            :filter-node-method="filterNode"
            @check-change="handleCheckChange"
          >
          </rs-org-tree>
          <rs-org-tree
            @ready="isready"
            v-else
            :props="props"
            :node-key="nodeKey"
            class="rs-org-select-tree singleSelect"
            ref="tree"
            default-expand-all
            :expand-on-click-node="false"
            highlight-current
            :render-content="renderContent"
            :data="treeArr"
            :filter-node-method="filterNode"
            @current-change="currentChange"
          >
          </rs-org-tree>
        </div>
      </div>
    </rs-collapse-transition>
    <div class="rs-org-select-tree-modal" v-show="showTreeBox" @click="showTreeBox=false"></div>
  </div>
</template>
<script>
// import '@/assets/css/components/org-select.scss'
export default {
  name: 'RsOrgSelect',

  props: {
    treeData: {
      type: Array
    },
    placeholder: {
      type: String,
      default: '请选择组织'
    },
    halfChecked: Boolean,
    multiple: Boolean,
    multipleLimit: {
      type: Number,
      default: 0
    },
    size:String,
    nodeKey: {default: 'id'},
    value: {},
    props: {
      default:function(){
        return {
          label:'label',
          id:'id',
          value:'value',
          children:'children'
        }
      }
    },
  },
  data(){
    return{
      inputVal:'',
      filterText:'',
      showTreeBox:false,
      hasChecked:[],
      hasClicked:null,
      defaultCheckedKeys:[]
    }
  },
  created(){

  },
  computed:{
    treeArr(){
      return this.treeData;
    },
    inputPlaceholder() {
      return this.placeholder;
    },
  },
  watch: {
    value:{
      handler(val){
        if(!val){return}
        if(this.multiple&&val.length>0){
          this.hasChecked = val
        }else{
          this.hasClicked = val
        }
        this.setValue()
      },
      deep:true,
      immediate:true
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },

  },
  mounted(){
  },
  methods:{
    handleFocus(){
      this.filterText = ''
      this.showTreeBox = true
      this.$nextTick(function(){
        this.setValue()
      })
    },
    setValue(val){
      console.log('setValue')
      if(this.$refs.tree&&this.treeData&&this.treeData.length>0){
        if(this.multiple&&this.hasChecked.length>0){
          this.$refs.tree.setCheckedKeys(this.hasChecked)
        }else if(!this.multiple&&this.hasClicked){
          this.$refs.tree.setCurrentKey(this.hasClicked)
          console.log('treeData:-----',this.treeData);
          console.log('hasClicked:-----',this.hasClicked);
          this.getLabel(this.treeData,this.hasClicked)
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data[this.props.label].indexOf(value) !== -1;
    },
    currentChange(data){
      if(!data.disabled) {
        this.inputVal = data[this.props.label]
        this.showTreeBox = false
        this.hasClicked = data.id
        this.$emit('change',data)
      }
    },
    getHalfCheckedNodes() {
      return this.$refs.tree.getHalfCheckedNodes()
    },
    getCheckedNodes() {
      return this.$refs.tree.getCheckedNodes()
    },
    handleCheckChange() {
      let checked = this.$refs.tree.getCheckedNodes()
      this.hasChecked = this.$refs.tree.getCheckedKeys()
      let halfChecked = []
      if(this.halfChecked){
        halfChecked = this.getHalfCheckedNodes()
      }
      let data = [...checked,...halfChecked]
      this.inputVal = data.length==0?'':`已选择${data.length}项`
      this.$emit('change',data)
    },
    clearInputValue(){
      this.inputVal = ''
      if(this.multiple) {
        this.$refs.tree.setCheckedKeys([])
        this.$refs.tree.setCurrentKey([])
      }
    },
    setCurrentKey(val) {
      this.$nextTick(()=>{
        this.$refs.tree.setCurrentKey(val)
      })
    },
    renderContent(h, { node, data, store }) {
      let spanhtml = `<span>${node.label}</span>`
      let imgClass = data.parentOrgSysCode == '0' ? 'org-png' :'file-png'
      if(imgClass=='org-png'){
        return (
          <span style='font-size:14px;' data-status={data.disabled}>
                            <i class="iconfont iconzendai-icon-zuzhijiagou" style='margin-right:6px'></i>
                            <span domProps-innerHTML={spanhtml}></span>
                    </span>
        );
      }else{
        return (
          <span style='font-size:14px;' data-status={data.disabled}>
                            <i class="iconfont iconzendai-icon-zuzhijiagouwenjianjia" style='margin-right:6px;font-size:12px'></i>
                            <span domProps-innerHTML={spanhtml}></span>
                    </span>
        );
      }
    },
    getLabel(arr,id){
      console.log('nodeKey:-------',this.nodeKey);
      for(let i=0;i<arr.length;i++){
        console.log('treeDataItem:--------',arr[i]);
        if(arr[i][this.nodeKey]==id){
          this.inputVal = arr[i][this.props.label]
          console.log('this.inputVal:--------',this.inputVal);
          return
        }else if(arr[i][this.props.children]&&arr[i][this.props.children].length>0){
          this.getLabel(arr[i][this.props.children],id)
        }
      }
    },
    isready(val){
      console.log('ready');
      this.setValue()
    }
  },

};
</script>